import React from 'react'
import Player from '@vimeo/player';

class VimeoPlayer extends React.Component {


  constructor(){
    super();

    this.state = {
      playing:false,
      player : ''
    }

    this.playVideo = this.playVideo.bind(this)
    this.videoStopped = this.videoStopped.bind(this)
    this.closeVideo = this.closeVideo.bind(this)
  }


  playVideo(){
    console.log("Play Video");
    var iframe = this.refs.video_iframe
    var player = new Player(iframe);
        player.play()

        player.on('ended',() =>{
          console.log("Video Ended");
          this.videoStopped();
        })
        player.on('play',()=>{
          console.log("Video Playing");
        })

        this.setState({playing:true})

        this.hideMenuAndLogo()
  }

  hideMenuAndLogo(){

    // HACK: This is to hide a the logo on iOs devices because the z-index is not working properly

    if(window.navigator.userAgent.indexOf('iPhone') !==-1 || window.navigator.userAgent.indexOf('iPad') !==-1){
      console.log("Hack to HIDE logo and menu on iOS");
      if(document.querySelector('.main-menu')){
        document.querySelector('.main-menu').classList.add('hide');
      }
      if(document.querySelector('.logo')){
        document.querySelector('.logo').classList.add('hide');
      }
    }
  }
  showMenuAndLogo(){

      // HACK: This is to hide a the logo on iOs devices because the z-index is not working properly
      
      if(window.navigator.userAgent.indexOf('iPhone') !==-1 || window.navigator.userAgent.indexOf('iPad') !==-1 ){
        console.log("Hack to SHOW logo and menu on iOS");
        if(document.querySelector('.main-menu')){
          document.querySelector('.main-menu').classList.remove('hide');
        }
        if(document.querySelector('.logo')){
          document.querySelector('.logo').classList.remove('hide');
        }
      }
  }

  videoStopped(){
        this.setState({playing:false})
        this.showMenuAndLogo()
  }

  closeVideo(){
      this.showMenuAndLogo()

      this.refs.video_iframe.setAttribute('src',this.refs.video_iframe.getAttribute('src'))
      this.setState({playing:false})

  }

  render(){

      let videoId;


      // get the id

      videoId = this.props.video.split('/').pop();

      //console.log(videoId);

      //console.log(this.props);

      return (
        <div className={(this.state.playing)? 'vimeo-player playing' : 'vimeo-player not-playing'}>
          <div className="iframe-container">
            <iframe ref="video_iframe" src={"https://player.vimeo.com/video/"+videoId+"?color=f4f4f4&title=0&byline=0&portrait=0&hd=1"} allowFullScreen></iframe>
          </div>

          <div className="play-btn" onClick={this.playVideo}></div>
          {(this.state.playing)?
            <div className="close-button" onClick={this.closeVideo}></div>
            : null
          }
        </div>
      )
  }
}

export default VimeoPlayer



// WEBPACK FOOTER //
// ./src/modules/misc/VimeoPlayer.js